import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { F, Button, Flex } from 'nallian-shared-ui/lib/components';
import Feature from './Feature';

const FieldFlex = styled(Flex)`
  && .field {
    width: 100%;
  }
`;

const FieldLabel = styled.label`
  margin: 0 0 0.28571429rem 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.92857143em;
  font-weight: bold;
`;

const FeatureFields = ({ features, fields, submitProcessing, readOnly, editMode }) => {
  const { t } = useTranslation();

  const handleAddFieldClick = useCallback(
    () => fields.push({ isNew: true, requiresSubscription: true }),
    [fields]
  );
  const handleRemoveFieldClick = useCallback((_, { i }) => fields.remove(i), [fields]);

  return (
    <F.Field error={false}>
      <Flex fluid direction="column">
        <FieldLabel htmlFor="-">{t('features')}</FieldLabel>
        <FieldFlex fluid direction="column" alignItems="flex-start">
          {fields.map((f, index) => (
            <Feature
              features={features}
              index={index}
              fields={fields}
              editMode={editMode}
              field={f}
              readOnly={readOnly}
              key={`feature_${index.toString()}`}
              handleRemoveFieldClick={handleRemoveFieldClick}
              submitProcessing={submitProcessing}
            />
          ))}
          {!readOnly && fields.length < features?.length && (
            <Flex fluid justifyContent="flex-end" margin="1rem 0 0 0">
              <Button
                linkbutton
                icon="add"
                type="button"
                tabindex="-1"
                content={t('addFeature')}
                onClick={handleAddFieldClick}
              />
            </Flex>
          )}
        </FieldFlex>
      </Flex>
    </F.Field>
  );
};

FeatureFields.propTypes = {
  fields: PropTypes.array.isRequired,
  submitProcessing: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  features: PropTypes.array,
};

FeatureFields.defaultProps = { features: [] };

export default FeatureFields;
